
// 시스템 구성
// 라이센스 관리
//
// @since 2018-04-10
// @author 강정규 ( devp012 )

import compareObject from '~/utils/compare'

export const state = () => ({
  selectedHaUuid: -1, // HA 인 경우 선택된 서버 uuid
  urlConfig: '/api/sm/license/config', // 라이선스 기본 정보 URL
  urlSchedule: '/api/sm/license/scheduler', // 라이선스 스케쥴 URL
  urlVolume: '/api/sm/license/config/ve-volume', // 라이선스 볼륨 URL
  urlImport: '/api/co/file/import', // 라이선스 업데이트 URL
  scheduleParamOrigin: {}, // 라이선스 스케쥴 원본 데이터
  licenseParam: { // 라이선스 정보
    LicenseInfo: { //     required (object)
      SWSerial: '', //    required (string) 시리얼 번호
      ID: '', //          required (string) ID
      TERM: '', //        required (string) 라이선스 기간
      LicenseKey: '', //  required (string) 제품 라이선스
      ClientCode: '', //  required (string) 클라이언트 코드
      IssueDate: '', //   required (string) Issue Date
      SWType: '' //       required (string) H/W 시리얼 번호
    },
    SWFeature: { //     required (array of items) Items: items
    // [
    //   id: '', //         required (integer) ID
    //   Name: '', //       required (string) Feature 이름
    //   Use: true, //      required (boolean) Feature 사용
    //   Option: '', //     required (string) Feature 옵션
    // ]
    }
  },
  licenseUpdateTab: { // 파일 업데이트 탭에서의 라이선스 정보
    LicenseInfo: {
      SWSerial: '',
      LicenseKey: '',
      TERM: '',
      HWSerial: '',
      SWType: ''
    }
  },
  licenseVolumeInfo: {
    code: 0,
    max: 0,
    use: 0,
    updateTime: '',
    desc: ''
  },
  licenseUpdateResult: { // 라이선스 업로드 결과
    check: 0,
    reboot: 0
  },
  licenseMgmtData: { // 라이선스 관리 탭의 virtual System 사용 여부 변경 체크
    vsUse: 'false',
    oldValue: 'false'
  },
  scheduleParam: { // 스케쥴 탭 입력 내용
    update_on: 0, // required (one of 0, 1) 자동 업데이트 사용(OFF: 0, ON: 1)
    hour: 0, //      required (integer - minimum: 0 - maximum: 23) 시간(시)
    min: 0, //       required (integer - minimum: 0 - maximum: 23) 시간(분)
    days: [1, 1, 1, 1, 1, 1, 1] //  required (array of ) 요일별 배열 순번(일: 0, 월: 1, 화: 2, 수: 3, 목: 4, 금: 5, 토: 6)
    //                        요일 ON/OFF(OFF: 0, ON: 1)
  }
})

export const mutations = {
  // 선택된 이중서 서버 uuid 저장
  setSelectedHaUuid: (state, haValue) => {
    state.selectedHaUuid = haValue
  },
  // URL의 prefix 변경
  setHaPrefix: (state, apiPrefix) => {
    state.urlConfig = `${apiPrefix}api/sm/license/config`
    state.urlSchedule = `${apiPrefix}api/sm/license/scheduler`
    state.urlImport = `${apiPrefix}api/co/file/import`
  },
  // 라이선스 정보 조회
  getLicenseInfo: (state, item) => {
    state.licenseParam = item
  },
  // 라이선스 업데이트 정보 조회
  getLicenseInfoUpdate: (state, item) => {
    state.licenseUpdateTab = item
  },
  getLicenseVolumeInfo: (state, item) => {
    state.licenseVolumeInfo = item
  },
  // 라이선스 업데이트 정보 초기화
  initLicenseInfoUpdate: (state) => {
    state.licenseUpdateTab.LicenseInfo.SWSerial = ''
    state.licenseUpdateTab.LicenseInfo.LicenseKey = ''
    state.licenseUpdateTab.LicenseInfo.TERM = ''
    state.licenseUpdateTab.LicenseInfo.HWSerial = ''
    state.licenseUpdateTab.LicenseInfo.SWType = ''
  },
  // 라이선스 스케쥴 정보 조회
  getLicenseSchedule: (state, item) => {
    state.scheduleParam = item
    state.scheduleParamOrigin = _.cloneDeep(item)
  },
  initStoreLicenseVolumeTab (state) {
    state.licenseVolumeInfo = { // 라이선스 정보
      code: 0,
      max: 0,
      use: 0,
      updatetime: '',
      desc: ''
    }
  },
  // TAMS
  initStoreLicenseMgmtTab (state) {
    state.licenseParam = { // 라이선스 정보
      LicenseInfo: {
        SWSerial: '',
        ID: '',
        TERM: '',
        LicenseKey: '',
        ClientCode: '',
        IssueDate: '',
        SWType: ''
      },
      SWFeature: {}
    }
    state.licenseMgmtData = {
      vsUse: 'false',
      oldValue: 'false'
    }
  },
  initStoreLicenseFileUpdateTab (state) {
    state.licenseUpdateTab = {
      LicenseInfo: {
        SWSerial: '',
        LicenseKey: '',
        TERM: '',
        HWSerial: '',
        SWType: ''
      }
    }
    state.licenseUpdateResult = {
      check: 0,
      reboot: 0
    }
  }
}

export const actions = {
  // 파일 업로드
  async importFile ({state}, file) {
    const fd = new FormData()
    fd.append('file', file)
    const data = await this.$axios.$post(state.urlImport, fd, {successAlert: false, loadingHide: false})
    if (data.code === 'ok') {
      return data.result.file
    }
  },
  // Tams license 조회
  async getLicenseInfo ({state, commit}) {
    try {
      const data = await this.$axios.$get(`${state.urlConfig}`)
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, false)
        if (!_.isUndefined(data.result.message)) {
          return false
        } else {
          commit('getLicenseInfo', data.result)
          return true
        }
      }
      return false
    } catch (e) {
      return false
    }
  },
  async setLicenseInfo ({state}, password) {
    const param = {
      vs: {
        old: state.licenseMgmtData.oldValue === 'on',
        new: state.licenseMgmtData.vsUse === 'on'
      },
      pw: btoa(password)
    }
    const data = await this.$axios.$put(state.urlConfig, param)
    if (data.code === 'ok') {
      return true
    }
    return false
  },
  async updateLicenseInfo ({state, commit, rootState}, fileName) {
    const param = {
      filename: fileName
    }
    try {
      const data = await this.$axios.$post(`${state.urlConfig}`, param, {loadingShow: false, successAlert: false})
      if (data.code === 'ok' && _.isUndefined(data.result.err)) {
        commit('getLicenseInfoUpdate', data.result)
        this.dispatch(`common/common/setIsChanged`, true)
        // }
      }
      return data
    } catch (error) {
      return {code: 'nok'}
    }
  },
  async getLicenseVolumeInfo ({state, commit}) {
    try {
      const data = await this.$axios.$get(`${state.urlVolume}`)
      if (data.code === 'ok') {
        commit('getLicenseVolumeInfo', data.result)
      }
      return data
    } catch (e) {
      return false
    }
  },
  async initLicenseInfoUpdate ({commit}) {
    this.dispatch(`common/common/setIsChanged`, false)
    commit('initLicenseInfoUpdate')
  },
  async getLicenseSchedule ({state, commit}) {
    const data = await this.$axios.$get(state.urlSchedule)
    if (data.code === 'ok') {
      commit('getLicenseSchedule', data.result)
      return true
    }
    return false
  },
  async setLicenseSchedule ({state, commit}) {
    const res = await this.$axios.$put(state.urlSchedule, state.scheduleParam)
    if (res.code === 'ok') {
      commit('getLicenseSchedule', res.result)
      return true
    }
    return false
  },

  async finalCommand ({state, commit, rootState}, fileName) {
    const param = {
      filename: fileName
    }
    const result = await this.$axios.$put(`${state.urlConfig}/apply`, param, {successAlert: false})
    if (result.code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      commit('initLicenseInfoUpdate')
    }
    return result
  },

  async cancelCommand ({state, commit, rootState}, fileName) {
    const param = {
      filename: fileName
    }
    const result = await this.$axios.$put(`${state.urlConfig}/cancel`, param, {successAlert: false})
    if (result.code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      commit('initLicenseInfoUpdate')
    }
    return result
  }
}

export const getters = {
  // 라이선스 정보 변경 체크
  compareLicenseMgmtData (state) {
    return state.licenseMgmtData.vsUse === state.licenseMgmtData.oldValue
  },
  // 라이선스 업데이트 스케줄 정보 변경 체크
  compareLicenseUpdateScheduler (state) {
    return compareObject(state.scheduleParam, state.scheduleParamOrigin)
  }
}

export const strict = false
